import { TooltipProps } from 'opensolar-ui'
import PropTypes from 'prop-types'
import { Record } from 'ra-core'
import type { CSSProperties, ReactElement } from 'react'

type TextAlign = 'right' | 'left'
export interface FieldProps {
  addLabel?: boolean
  sortBy?: string
  source?: string
  label?: ReactElement | string
  sortable?: boolean
  className?: string
  cellClassName?: string
  /** Inline styles merged onto the body cell (`DatagridCell` → `<td>`). */
  cellStyle?: CSSProperties
  headerClassName?: string
  /** Inline styles merged onto the header cell (`DatagridHeaderCell` → `<th>`). */
  headerStyle?: CSSProperties
  textAlign?: TextAlign
  emptyText?: string
  fieldKey?: string
  overrideValueFunc?: any
  displayInCard?: boolean
  tooltipProps?: TooltipProps
}

// Props injected by react-admin
export interface InjectedFieldProps {
  basePath?: string
  record?: Record
}

export const fieldPropTypes = {
  addLabel: PropTypes.bool,
  sortBy: PropTypes.string,
  source: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sortable: PropTypes.bool,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  cellStyle: PropTypes.object,
  headerClassName: PropTypes.string,
  headerStyle: PropTypes.object,
  textAlign: PropTypes.oneOf<TextAlign>(['right', 'left']),
  emptyText: PropTypes.string,
  fieldKey: PropTypes.string,
  displayInCard: PropTypes.bool,
}
